'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    TAssignAdminRolePayload,
    TAssignAdminRoleResponse,
} from '../../types/admin-management/admin-roles-types';

import { assignAdminRole } from '../../services/adminService';
import { TErrorResponse } from '../../types/error-response';

const useAssignAdminRole = () => {
    const queryClient = useQueryClient();
    const { data, mutate, isPending, error, isSuccess, isError } = useMutation<
        TAssignAdminRoleResponse,
        TErrorResponse,
        TAssignAdminRolePayload,
        unknown
    >({
        mutationFn: (payload) => assignAdminRole(payload),
        onSuccess: (response) => {
            queryClient.invalidateQueries({ queryKey: ['get-admins'] });
        },
    });
    return { data, mutate, isPending, error, isSuccess, isError };
};

export default useAssignAdminRole;
